var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 140.9 101.7" },
      attrs: {
        version: "1.1",
        id: "Ebene_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 140.9 101.7",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { attrs: { id: "Ebene_2_1_" } }, [
        _c("g", { attrs: { id: "Ticketshop" } }, [
          _c("path", { attrs: { d: "M8.9,46.7" } }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M139.618,44.703c0.198-0.838,0.286-1.705,0.253-2.577c-0.042-1.149-0.293-2.308-0.772-3.426l0,0L125.5,6.9\n        c-2.1-4.9-7.8-7.2-12.7-5.1l0,0L24.338,39.365",
            },
          }),
          _vm._v(" "),
          _c("circle", { attrs: { cx: "27.2", cy: "81.6", r: "12.7" } }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M10.5,46.7h111.2c5.3,0,9.5,4.3,9.5,9.5v35c0,5.3-4.3,9.5-9.5,9.5H10.5c-5.3,0-9.5-4.3-9.5-9.5v-35\n        C1,51,5.3,46.7,10.5,46.7z",
            },
          }),
          _vm._v(" "),
          _c("line", {
            attrs: { x1: "108.883", y1: "47.024", x2: "108.883", y2: "59.398" },
          }),
          _vm._v(" "),
          _c("line", {
            attrs: { x1: "108.883", y1: "89.927", x2: "108.883", y2: "100.7" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("line", {
        attrs: { x1: "47.644", y1: "61.834", x2: "91.527", y2: "61.834" },
      }),
      _vm._v(" "),
      _c("line", {
        attrs: { x1: "108.883", y1: "68.769", x2: "108.883", y2: "81.142" },
      }),
      _vm._v(" "),
      _c("line", {
        attrs: { x1: "47.644", y1: "74.17", x2: "91.527", y2: "74.17" },
      }),
      _vm._v(" "),
      _c("line", {
        attrs: { x1: "47.644", y1: "86.507", x2: "66.1", y2: "86.507" },
      }),
      _vm._v(" "),
      _c("line", {
        attrs: { x1: "59.482", y1: "38.295", x2: "94.495", y2: "23.538" },
      }),
      _vm._v(" "),
      _c("line", {
        attrs: { x1: "88.029", y1: "38.106", x2: "100.962", y2: "32.655" },
      }),
      _vm._v(" "),
      _c("line", {
        attrs: { x1: "100.239", y1: "7.848", x2: "105.491", y2: "19.052" },
      }),
      _vm._v(" "),
      _c("line", {
        attrs: { x1: "108.883", y1: "26.468", x2: "114.135", y2: "37.672" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }